export default {
  ENTER_NAME: `名前を入力`,
  JOIN: `今すぐ参加`,
  CHOOSE_A_PICTURE: `アイコン選択`,
  SUPPORTED_BY: `技術提供 by NetEase IM`,
  MEETING_EXPIRED: `無効な会議リンクです`,
  GRID_VIEW: `ギャラリー表示`,
  PRESENTER_VIEW: `発表者画面表示`,
  EXPAND: `参加者を表示`,
  COLLAPSE: `参加者を非表示`,
  NO_DEVICE: `利用可能なデバイスが見つかりませんでした。他のデバイスを接続又は再度お試しください。`,
  CONFIRM_LEAVE: `会議を退出してもよろしいですか？`,
  BROWSER: `ブラウザ`,
  LOOKING_AT_THE_SCREEN: `{name}の画面を表示しています`,
  DEVICE_NAME: `デバイス名称`,
  MUTE_ON_ENTRY: `司会者の設定によりミュートがデフォルトになっております`,
  NOT_ALLOWED_TURNED_ON_DEVICE: `マイクONにしている人数が多いため、司会者よりマイクを禁止しております。`,
  NEW_HOST: `{name}が司会者となりました`,
  OFFLINE: `ネットワーク接続異常、インターネット設定をチェックしてください。`,
  CONNECTION_IS_UNSTABLE: `ネットワーク状態が不安定です`,
  UNSTABLE_CONNECTION: `接続が不安定です`,
  TRYING_TO_RECONNECT: `再接続中…`,
  CONNECTION_FAILED: `接続失敗`,
  NETWORK_CONNECTION_FAILED: `インターネットの接続に失敗、通話が切れました。`,
  THE_HOST_ASKED_TO_TURN_ON_YOUR_CAMERA: `司会者からカメラONの請求です`,
  REJECT: `拒否`,
  OPEN: `ONにする`,
  EXPERIENCE: `今回のビデオ会議の体験はいかがでしたでしょうか？`,
  OTHER_FEEDBACK: `他にご意見ありますか？`,
  THANKS: `POPO ミーティングをご利用いただきありがとうございました`,
  CANCEL: `キャンセル`,
  LEAVE: `退出`,
  SUBMIT: `提出`,
  DURATION: `会議時間`,
  GREAT: `良き体験でした`,
  ISSUES: `改善の余地あり`,
  REQUEST_MIC: `POPOはマイク使用権限の許可を求めています`,
  REQUEST_CAMERA: `POPOはカメラ使用権限の許可を求めています`,
  REQUEST_MIC_CONTENT: `【設定】-【プラパーツ】にてPOPOのマイク権限をONにしてください`,
  REQUEST_CAMERA_CONTENT: `【設定】-【プラパーツ】にてPOPOのカメラ権限をONにしてください`,
  CONFIRM: `もちろん`,
  INVITE_YOU_TO_THE_MEETING: `から会議に招待されています`,
  CONFERENCE_THEME: `会議テーマ`,
  CONFERENCE_NUMBER: `会議ID`,
  CONFERENCE_LINKS: `会議リンク`,
  ALLOW_MEMBERS_TO_JOIN_THROUGH_WEB_BROWSER: `メンバーのブラウザからの参加を許可`,
  THE_MEETING_INFORMATION_HAS_BEEN_COPIED_TO_THE_CLIPBOARD: `コピー完了`,
  SHARE_TO_CONVERSATION: `チャットへ共有`,
  COPY_MEETING_LINK: `コピー`,
  SHARE_INVITATION_CARD: `招待カードを共有`,
  STOP_SHARE: `{name}は画面共有を中止しました`,
  START_TIME: `開始時間`,
  SPEAKING: `発言者：`,
  HOST: `司会者`,
  CAMERA: `カメラ`,
  MICROPHONE: `マイク`,
  SPEAKER: `スピーカー`,
  TURNED_OFF_MIC_BY_HOST: `司会者よりミュートされました`,
  TURNED_OFF_CAMERA_BY_HOST: `司会者よりカメラをOFFにされました`,
  MEETING_ENDING: `会議終了`,
  MEETING_NOT_EXIST: `存在しない会議です`,
  LEAVE_MEETING: `会議を退出`,
  KICK_OUT: `司会者より会議から削除されました`,
  CAMERA_ON: `カメラON`,
  CAMERA_OFF: `カメラOFF`,
  MIC_ON: `ミュートを解除`,
  MIC_OFF: `ミュートにする`,
  SETTINGS: `設定`,
  THE_MODERATOR_HAS_CLOSED_THE_CHAT_IN_THE_MEETING: `司会者より会議内チャートを無効にしました`,
  THE_HOST_HAS_TURNED_OFF_THE_MEETING_CHAT_FUNCTION: `司会者より当該会議内のチャートを無効にしました`,
  THE_HOST_HAS_STARTED_CHATTING_IN_THE_MEETING: `司会者より会議内チャートを有効にしました`,
  CHAT: `チャート`,
  NEW_NEWS: `新メッセージ`,
  NO_MORE_NEWS: `新メッセージなし`,
  LOADING: `ローディング`,
  SEND_A_MESSAGE_TO_EVERYONE: `全員にメッセージを送信…`,
  SEND: `送信`,
  LINE_FEED: `改行`,
  ME: `私`,
  SWITCH_MIC_TIPS: `マイクONの状態のみデバイスを切り替え可能`,
  AUDIOVIDEO_CONFERENCE: `ビデオ会議`,
  MEMBER_MANAGEMENT: `メンバー管理`,
  CLOSE: `クローズ`,
  MEMBER: `メンバー`,
  HOST_OPEN_MIC: `司会者からマイクONの請求です`,
  HOST_OPEN_CAMERA: `司会者からカメラONの請求です`,
  IOS_UNDER_13: `Ios 13以下のシステムバージョンはサポートしていません。アップデートしてから再度お試しください。`,
  NOT_SHARE_SCREEN: `画面を共有できません`,
  SYSTEM_PREFERENCES_RMISSION: `環境設定にて現在のブラウザにスクリーンレコード権限を与えてから画面共有ができるようになります`,
  ANYONE_SHARING_THE_SCREEN: `{name}は画面を共有しています`,
  ARE_YOU_SURE_YOU_WANT_TO_STOP_SCREEN_SHARING: `画面共有を中止してもよろしいですか？`,
  YOU_ARE_SHARING_THE_SCREEN: `画面を共有しています`,
  STOP_SHARING: `共有中止`,
  SHARE_SCREEN: `画面共有`,
  OPEN_WHITEBOARD: `ホワイトボードを開く`,
  STOP_WHITEBOARD: `ホワイトボードを閉じる`,
  WHITEBOARD_OPENED: `インタラクティブホワイトボードがオープンしました`,
  FAILED_TO_OPEN_WHITEBOARD_BECAUSE_OF_SCREEN_SHARING: `画面共有が有効になっている、インタラクティブホワイトボードが禁止されている`,
  FAILED_TO_OPEN_WHITEBOARD_BECAUSE_OF_DUPLICATED: `インタラクティブホワイトボードが開かれているため、繰り返し開くことはできません`,
  FAILED_TO_SCREEN_SHARING_BECAUSE_OF_WHITEBOARD: `インタラクティブホワイトボードがオンになっている、画面共有が禁止されている`,
  FAILED_TO_SCREEN_SHARING_BECAUSE_OF_DUPLICATED: `画面共有がオンになっていて、繰り返しオンにすることはできません`,
  EXPORT_BEFORE_TERMINATE_WHITEBOARD: `ホワイトボードを終了する前に、現在のコンテンツをエクスポートする必要がありますか？`,
  SNAPSHOT: `スナップショット`,
  EXPORT_TO_CLOUD_SPACE: `クラウドスペースへのエクスポート`,
  EXPORT_TO_LOCAL: `ローカルにエクスポート`,
  EXPORTED_TO_CLOUD_SPACE: `私のスペースにエクスポート`,
  TERMINATE: `終了`,
  EXPORT: `書き出す`,
  DONT_EXPORT: `出力しない`,
  PERSPECTIVE_SYNCHRONIZATION: `パースペクティブ同期`,
  CURRENT_PARTICIPANTS_WILL_FOLLOW_YOUR_PERSPECTIVE: `現在の参加者はあなたの視点に従います`,
  THE_PERSPECTIVE_SYNCHRONIZATION_HAS_BEEN_TURNED_ON: `パースペクティブ同期がオンになり、現在の参加者がパースペクティブに従います`,
  FAILED_TO_OPEN_WHITEBOARD_BECAUSE_OF_PERMISSION: `司会者のみがホワイトボードを開けます`,
  PERSPECTIVE_SYNCING: `パースペクティブ同期`,
  PERSPECTIVE_OF: `視点`,
  YOU_WILL_FOLLOW: `あなたがフォローします`,
  PERSPECTIVE_SYNCHRONIZATION_IS_TURNED_ON: `パースペクティブ同期がオンになっている`,
  YOU_ARE_CURRENTLY_IN_PERSPECTIVE_SYNCHRONIZATION: `現在、パースペクティブ同期中です`,
  TOOLBAR_SELECT: `選ぶ`,
  TOOLBAR_BRUSH: `みがきます`,
  TOOLBAR_SHAPE: `形`,
  TOOLBAR_ERASER: `ゴム`,
  TOOLBAR_LASER: `レーザーポインター`,
  TOOLBAR_TEXT: `文章`,
  ZOOM_TO_100: `100％にズーム`,
  ZOOM_IN: `拡大`,
  ZOOM_OUT: `ズームアウトする`,
  SCALE_TO_PROPER_SIZE: `適切なサイズに拡大縮小する`,
  MOVE_CANVAS: `キャンバスを移動する`,
  STOP: `中止`,
  UNABLE_OPEN_VIDEO_ON_SCREEN: `画面共有中にはビデオを流せません`,
  INPUT_OLD_CLOSE_CARAME: `旧バージョンを利用しているユーザーがいます。会議体験をよくするため、共有時にカメラの使用を禁止しております。`,
  DIVIECE_DISABLE_MAC: `[システム環境設定][セキュリティとプライバシー]で、ブラウザのデバイス権限をオンにしてください`,
  DIVIECE_DISABLE_IOS: `デバイス権限を取得していません。設定>Safariブラウザ>ネットサイト設定にてアクセス権限を授与し、ページをリロードしてください。`,
  DIVIECE_DISABLE_ANDROID: `システム設定にてブラウザのデバイス権限をONにしてください`,
  DIVIECE_DISABLE_WINDOWS: `デバイス権限を取得していません。ブラウザ設定>プライバシー設定>ネットサイト設定にてアクセス権限を授与し、ページをリロードしてください。`,
  DIVIECE_DISABLE_TITLE: `デバイスの電源投入に失敗する`,
  BROWER_DISABLE: `現在のブラウザには対応しておりませんので、会議アドレスをコピーして{name}ブラウザで開いてください`,
  COPY_URL: `会議のアドレスをコピーする`,
  COPY_SUCCESS: `複製に成功する`,
  BROWSER_INCOMPATIBLE: `現在使用しているブラウザの互換性に問題がある`,
  BROWSER_VERSION_UP: `{baseVersion}バージョンとそれ以上の{browser}ブラウザをお使いください。`,
  DOWNLOAD_BROWSER: `ブラウザをダウンロードする`,
  MIC_INCOMPATIBLE: `POPO会議、オーディオ機器の再生権限付与を要求`,
  MIC_CLICK_ABLE: `ブラウザのページ制限は、権限付与をクリックしてください。`,
  DISABLE_TOKEN: `登録期限が切れたので,会議のアドレスを再入力して登録してください`,
  WHAT_PROBLEM: `どんな問題にぶつかったか?`,
  PBDYP: `あなたの質問を簡単に説明してください`,
  OTHER: `他の`,
  FEEDBACK1: `会議に参加できない`,
  FEEDBACK2: `麦がとれない`,
  FEEDBACK3: `カメラがオンにならない`,
  FEEDBACK4: `音声の問題`,
  FEEDBACK5: `ビデオ問題`,
  FEEDBACK6: `画面共有問題`,
  PROMPT: `提示`,
  FEEDBACK: `フィードバック`,
  CHANGENET: `現在のネットワーク異常、他のネットワーク接続を変更して再試行してください`,
  CHECK_DEVICES_FIRST: `会議に参加する前に機器の点検をしてください`,
  CHECK_DEVICES: `装置の検査`,
  NO_DATA: `仮根拠`,
  MICROPHONE_CHECKER_TIPS: `一言待ってください、さっきの再生が聞こえますか?`,
  SPEAKER_CHECKER_TIPS: `ベルの音を聞きましたか。`,
  CHOOSE_MICROPHONE: `マイクを選ぶ`,
  CHOOSE_SPEAKER: `スピーカーを選ぶ`,
  OUTPUT_LEVEL: `出力レベル`,
  INPUT_LEVEL: `入力レベル`,
  YES: `は`,
  NO_SOUND_NEXT_SPEAKER: `次のスピーカーをテストします`,
  NO_VOICE_NEXT_MICROPHONE: `次のマイクをテストします`,
  TESTING_NTH_WITH_TOTAL_NUM: `第{number}項(共{total}項)をテスト中`,
  NEXT_STEP: `次のステップ`,
  SPEAKER_ERR: `スピーカーが正常に作動していません`,
  SPEAKER_MIC_ERR: `スピーカーとマイクが作動しませんでした`,
  DEVICE_NOT_WORK: `設備が正常に動作していない`,
  SPEAKER_MIC_WORKED: `スピーカーとマイクは正常に動作`,
  CHANGE_AUDIO_RECHECK: `利用可能な設備に交換し再調整してください`,
  END_CHECK: `テストを終了する`,
  RECHECK: `再テスト`,
  COMPLETE: `完成`,
  JOIN_MEETING: `会議に加わる`,
  RECORDING: `録音している`,
  BROADCASTING: `放送中`,
  MICROPHONE_RECORDING_TIPS: '録音中ですから一言言って待ってください',
  MICROPHONE_BROADCASTING_TIPS: '放送中だ、さっきの再生、聞いたか',
  APPLICATION: `応用`,
  WHITEBOARD: `インタラクティブホワイトボード`,
  EDITOR: `コードエディタ`,
  OPENING_INTERACTIVE_WHITEBOARD: `インタラクティブホワイトボードを開く`,
  OPENING_CODE_EDITOR: `コードエディタを開く`,
  EDITOR_CLOSED: `コード エディターを閉じる`,
  OPEN_EDITOR: `コード エディタが開きます`,
  SWITCHED_LANG: `ロケールが切り替わっている`,
  SCREEN_SHARED: `現在、画面を共有しています`,
  OTHER_SHAREDING_SCREEN: `現在、他のユーザーが画面を共有しています`,
  FAILED_TO_OPEN_CODE_EDITOR_BECAUSE_OF_SCREEN_SHARING: `コード エディタの開きは、共有状態ではサポートされていません`,
  FAILED_TO_OPEN_CODE_EDITOR_BECAUSE_OF_WHITEBOARD: `ホワイトボードがオンの場合、コード エディタは開くことができません`,
  FAILED_TO_SCREEN_SHARING_BECAUSE_OF_CODEEDITOR: `コード エディタが既に開いているので、現時点では画面共有をサポートできません`,
  REFRESH: `更新します`,
  CAMERA_IS_OFF: `カメラの電源が切れています`,
  MEETING_TIME: `会議の時間`,
  AGREE: `同意`,
  I_AGREE_TO_THE: `を同意します`,
  PRIVACY_POLICY: `プライバシーポリシー`,
  PLEASE_AGREE_TO: `を同意してください`,
  NETWORK_FAILED_REFRESH: `ネットワーク接続に失敗しました。`,
  SUPPORT_BY_QA_ZEN: `QA-Zenによるテクニカルサポート`,
  CLOSE_COLEDITOR: 'コード エディタを閉じますか?',
  WILL_CLOSE_FOR_ALL_MEETING_ATTENDEES:
    'コード エディタ ページは、すべての参加者に対して閉じられます',
  ACTIVATING_TRANSCRIPTION: `字幕を有効にしています`,
  TRANSCRIPTION_ACTIVATION_FAILED: `字幕の有効化に失敗しました`,
  TRY_AGAIN: `再試行`,
  TRANSCRIPTION_LANGUAGE: `ソース言語`,
  TRANSLATE_INTO: `ターゲット言語`,
  TRANSCRIPTION_LANGUAGE_WILL_BE_AUTOMATICALLY_DETECTED: `翻訳をオンにすると、ターゲット言語は自動的に認識され翻訳されます`,
  STOPPED_TRANSCRIPTION: `司会者が文字起こしをオフにしました`,
  REQUEST_TO_ACTIVATE_TRANSCRIPTION: `文字起こしオンを申請`,
  MEETING_TRANSCRIPTION: `文字起こし`,
  NO_TRANSLATE: `翻訳しない`,
  TRANSCRIPTION_IS_ENABLED: `{meetingName}転写が開始されました`,
  TRANSCRIPTION_IS_ENABLED1: `転写が開始されました`,
  TRANSCRIPTION_ENABLE_FAILED: `文字起こしを開始できませんでした`,
  AUTOMATICALLY_RECOGNIZED: `自動検出`,
  RECORD: `録画`,
  REQUEST_SENT: `司会者に申請しました`,
  REQUEST_RECORDING2: `司会者に録画を申請してオンにする`,
  MEETING_RECORDING_ENABLED: `録画がオンになっています`,
  REQUEST_RECORDING: `司会者に録画を申請しますか？`,
  REJECT_RECORDING: `司会者に拒否されました`,
  RECORDING2: `録画中`,
  RECORDING_PAUSED: `一時中止中`,
  RECORDING_RESUMED: `録画を再開しました`,
  RECORDING_STOPPED: `録画を停止しました`,
  RECORDING_CANNOT_BE_STARTED: `録画を一時的に開始できません`,
  MORE: `その他`,
  COLLAPSE2: `折り畳み`,
  DEVICE_IS_ABNORMAL: `デバイスが異常な場合は、デバイスを確認し、再試行を更新します`,
  INTERPRETATION_ENABLED: '司会者は同時通訳を有効にしました',
  INTERPRETATION_DISABLED: '司会者は同時通訳を無効にしました',
  INTERPRETATION: '同時通訳',
  HOST_UPDATED_YOUR_LANGUAGE_PAIR: '司会者が通訳の言語を更新しました',
  AUDIENCE_CHANNEL: 'チャンネル',
  MAIN_CHANNEL: 'オリジナル音声',
  POWERED_BY: 'Powered by NetEase Yunxin & NetEase AI Lab',
  INTERVIEW_CAMERA_TIPS:
    'カメラはデフォルトでオフになっています。準備が完了したら、オンにして下さい。面接の効果のため、面接中はカメラオンを保持して下さい。',
  ENTER_YOUR_NAME: '名前を入力',
  INTERPRETERS: '通訳者',
  UNMUTE_ORIGINAL_CHANNEL: 'メインチャンネルのミュートを解除',
  RECEIVE_MAIN_CHANNEL: 'オリジナル音声のミュートを解除',
  MAIN_CHANNEL_VOICE: '音量（オリジナル音声）',
  MAIN_CHANNEL_VOICE_H5: 'メインチャンネル',
  VOLUME: '音量',
  NOTIFY_PARTICIPANTS: '他の参加者を通知する',
  LOGIN: '登录',
  membershipTypeSelection: 'ログイン方法の選択',
  oscar: 'Oscar アカウントでログイン',
  supportedAccountTypes: 'OC、スタジオ専用のメールアカウントをサポート',
  usingOpenIDLogin: 'OpenIDでログイン',
  supportsCorpEmailAccount: 'Corpメールアカウントをサポート',
  guestLogin: 'ゲストモード',
  joinAsGuestEnabled: 'ゲストとしてログイン',
  youAreTheHost: 'あなたは主催者です',
  useNetEasePOPOClient: 'NetEase POPOアプリで会議に参加してください',
  openNetEasePOPOClient: 'NetEase POPOを起動する',
  downLoadPopo: 'NetEase POPOをダウンロード',
  noMeetingAccess: '会議に参加する権限がありません',
  contactMeetingOrganizer: '会議の主催者 {name} に連絡してください',
  disableSubtitles: '字幕オフ',
  enableSubtitles: '字幕オン',
  isEnablingSubtitles: '字幕をオンにしています',
  Chinese: '简体中文',
  automaticRecognition: '言語を検出する(Beta)',
  subtitleRegSourceLang: 'ソース言語',
  targetTrasLang: 'ターゲット言語',
  switchAccounts: 'アカウントの切り替え',
  guest: 'ゲスト',
  big: '大きい',
  small: '小さい',
  fontSize: 'テキストのサイズ',
  subtitleStatus: '字幕が生成できませんでした',
  transcribePaused: '文字起こしは中止されました',
  transcribe: '文字起こし',
  requestTranscriptionToHost: '文字起こしを開始するよう申請しますか',
  barrage: '字幕',
  translate: '翻訳',
  openTranscribe: '主催者が文字起こしをオンにしました',
  offTranscribe: '主催者が文字起こしをオフにしました',
  canNotOpenTranscribe: '現在文字起こし機能は利用できません',
  newSubtitle: '一番下へ',
  refuseToEnableTranscription: '書き起こしの拒否',
  realTimeTranscriptionTip:
    'リアルタイムで議事録を書き起こし、会議が終わったら学習鶏プラットフォームで書き起こし文書を見ることができる',
  noPermission: '司会者のみがホワイトボードを開けます',
  reaction: 'リアクション',
  handup: '手を挙げる',
  handoff: '手を下げる',
  xHandsRaising: '{count}人が手を挙げている',
  meetingReactionsAreDisabled: '司会者は、リアクション機能を無効にしました',
  emojiSent: '送信しました',
  cancelledYourRaiseOfHand: '司会者があなたの手を下げました',
  firstLoading: '読み込み中、少々お待ちください',
  emoLoadedFail: '読み込み失敗',
  reload: '再読み込み',
  exportTo: '{name}までエクスポート',
  audioCaptureFailed:
    'マイクに問題が発生しました。ページを更新するか、マイクが正しく接続されているかをご確認ください。',
  grid: '宮格',
  lecture: 'スピーチ',
  inTranscript: '転写中',
  meetingInformation: 'ミーティング情報',
  onShareing: '共有＃キョウユウ＃',
  devicAbnormality: '現在のデバイス例外',
  enableScreenSharing: '画面共有をオンにする',
  openSetting: '設定を開く',
  member: 'メンバー＃メンバー＃',
  enableAllFocusedTa: '全員にスポットライトを設定しました',
  disabledAllFocusedTa: 'スポットライトを終了しました',
  enableChangeFocusedTa: '全員にスポットライトを設定しました',
  codeEditorFocused: 'コード・エディタ/集中モード・プロセスでは、オフにして再試行してください',
  spotLighted: 'スポットライト',
  temporarilyUnmute: 'ミュートが一時的に解除されています',
  turnOnTheMicrophone: 'スペースキーを長押してミュートを一時的に解除',
  turnOffTheMicrophone: 'ミュートしました',
  isTalking: '話しています：',
  unableToSwitchLayout: '切り替えできません',
  inFocusedMode: '現在集中モード',
  transcriptionHelpTip:
    'リアルタイムの文字起こし、会議終了後にクラウドスペースで文字起こしファイルを閲覧可能。',
  interpretationBtnTooltip: 'この会議で同時通訳を有効にし、通訳者を指定する',
  availableMicrophoneIsNotDetected: '使用可能なマイクを検出できませんでした',
  unableToDetectCamera: '使用可能なカメラを検出できませんでした',
  internetConnectionTest: 'ネットワーク診断',
  password: 'パスワード',
  userName: '氏名',
  enterPassword: 'パスワードを入力してください',
  errorPassword: 'パスワードが正しくありません',
  mouse: 'マウス',
  laser: 'レーザースポットライト',
  select: '選択',
  pen: 'ペン',
  graph: '図形',
  text: 'テキスト',
  color: '色',
  eraser: '消しゴム',
  undo: '元に戻す',
  redo: 'やり直す',
  clear: 'すべてクリア',
  save: '保存',
  close: '閉じる',
  setSharertoAnnotate: '共有者のみ注釈を追加可能に設定しました',
  setSharertoAnnotateAll: '全員が注釈を追加可能に設定しました',
  openAnnotate: `{name} が注釈を有効にしました`,
  marker: 'ハイライター',
  lineWidth: '太さ',
  line: '線',
  oval: '楕円',
  arrow: '線矢印',
  rectangle: '長方形',
  replaceShare: '続行すると、現在共有されている画面がこの画面に置き換えられます。',
  confirm: '确认',
  meetingNeedPassword: '参加するにはパスワードが必要です',
  coHost: '連座司会者',
  becomeCoHost: '{name} が合同司会者になる',
  revokeHostPrivileges: '{name} 連座司会者権限が取り消されました',
  FAILED_TO_OPEN_WHITEBOARD_BECAUSE_OF_CODE_EDITOR:
    'コードエディターとホワイトボードを同時に使用できません',
  popoVersionOld: '共有者のPOPOのバージョンが古いため、注釈機能を使用できません',
  disableOpenAnnotate: '共有者のみ注釈を追加可能に設定しました',
  unableChangeColor: 'テキストの色を変更できません',
  openCodeFail: 'コードエディタのオープンに失敗しました',
  reOpen: '再オープン',
  videoCaptureFailed: '例外を収集するには、ページを更新するかマイクを確認してください',
  fullScreenView: 'アプリケーション内の全画面表示',
  reduceScreenSize: '画面を縮小',
  STOPPED_AI_MINUTES: '司会者がAI議事録を停止しました',
  STOPPED_AI_MINUTES_OTHER: '司会者がAI議事録を停止したため、議事録の表示が一時停止しました',
}
